import { ReactNode, useMemo, useState } from 'react';

import { GlobalContext } from '@/context/global/GlobalContext';
import { type GlobalContextType } from '@/context/global/types';

export function GlobalProvider({ children }: { children: ReactNode }) {
  const [userName, setUserName] = useState<GlobalContextType['userName']>(null);

  const value = useMemo(
    () => ({ userName, setUserName }),
    [userName, setUserName],
  );

  return <GlobalContext value={value}>{children}</GlobalContext>;
}
